import { axiosHelper } from 'Services/AxiosHelper';
import { OnUpdateCustomerAdressModel } from 'Models';
import { onUpdateCustomerAddressReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnUpdateCustomerAddress';

const onUpdateCommercialStatus = async (
  params: onUpdateCustomerAddressReqBodyData
): Promise<OnUpdateCustomerAdressModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onUpdateCommercialStatus;
